const messages = {
    "colorAxisHelp": "Notes belonging to the same axis on the circle of fifths share a color.",
    "colorCircleHelp": "Hue follows the circle of fifths. Notes with the same name have the same color in every octave.",
    "colorIntervalHelp": "Hue follows pitch and completes one cycle over the selected number of semitones.",
    "colorMonotoneHelp": "Use the same color for every note.",
    "colorMethod": "Color mapping",
    "colorPeriod": "Hue cycle",
    "colorCircle": "Circle of fifths",
    "colorInterval": "Pitch interval",
    "colorBasis": "Color by",
    "settings": "Settings",
    "about": "About",
    "settingsTitle": "Settings (Ctrl+, or ⌘+,)",
    "close": "Close",
    "closeSettings": "Close settings",
    "categories": "Settings categories",
    "connectionTab": "Connection",
    "visualizationTab": "Visuals",
    "uiTab": "UI",
    "chordsTab": "Chords",
    "immediate": "Changes apply and save immediately.",
    "errorTitle": "Could not complete the action",
    "recovery": "Check your device connection and browser MIDI permissions, then try again.",
    "dismiss": "Dismiss",
    "connection": "MIDI connection",
    "inputDevice": "Input device",
    "notConnected": "Not connected",
    "refresh": "Refresh inputs",
    "ignoreOctave": "Ignore octave differences",
    "ignoreOctaveHelp": "Light up every cell of the same pitch class and hide octave numbers.",
    "arrangementMethod": "Layout",
    "toolbarHeading": "Toolbar",
    "arrangement": "Note arrangement",
    "color": "Color scheme",
    "toolbar": "Show toolbar",
    "toolbarHelp": "The Settings button always remains available.",
    "channelColorLabel": "Channel color",
    "inputChannelsTab": "Input channels",
    "inputChannelsHelp": "Set transposition and destinations for each channel. Channel 10 (percussion) is excluded.",
    "channelToVisuals": "Visuals",
    "channelToChords": "Chord names",
    "percussionExcluded": "Percussion channel: excluded.",
    "chords": "Key and chord names",
    "key": "Key",
    "mode": "Scale / mode",
    "sharp": "Use sharp notes",
    "degrees": "Show chord names as degrees",
    "offset": "Transpose (semitones)",
    "offsetHelp": "−24 to +24 semitones. 12 semitones = one octave.",
    "offsetError": "Enter a whole number from −24 to +24. The previous setting is still applied.",
    "checking": "Checking MIDI inputs…",
    "connected": "Connected: {name}",
    "chooseInput": "Not connected. Choose an input device.",
    "noInputs": "No MIDI inputs found. Connect a device, then refresh.",
    "unavailable": "MIDI inputs unavailable. Check permissions and try Refresh inputs.",
    "connecting": "Connecting…",
    "disconnecting": "Disconnecting…",
    "errorMissingInput": "This MIDI input is no longer available. Choose another input or refresh the list.",
    "errorUnsupported": "Web MIDI is not available in this browser. Use a browser with Web MIDI support.",
    "errorPermission": "MIDI access was denied. Allow MIDI access in your browser settings, then refresh inputs.",
    "errorDevice": "The MIDI device could not be opened or closed. Check its connection and try again.",
    "errorUnknown": "An unexpected error occurred. Please try again.",
    "language": "Language",
    "automatic": "Automatic (browser language)",
    "aboutTitle": "About Midivis",
    "licenses": "Licenses",
    "licenseIntro": "All source code for this application is available under free and open-source licenses.",
    "appLicense": "Midivis License",
    "thirdParty": "Third-party licenses",
    "eventsLicense": "Node.js License",
    "eventsNotice": "This license applies to the events module.",
    "color.channel": "MIDI channel",
    "colorChannelHelp": "Each input channel has a color. Overlapping channels appear as bands. Channel 10 (percussion) is excluded.",
    "color.monotone": "Single color",
    "color.chromatic": "12 semitones (octave)",
    "color.fifth": "Circle of fifths",
    "color.axis": "Axis system",
    "color.quintave": "7 semitones (perfect fifth)",
    "color.third-major": "4 semitones (major third)",
    "arrangementVariant": "Shape and range",
    "arrangementGroup.interval": "Interval grids",
    "arrangementGroup.harmony": "Harmonic layouts",
    "arrangementGroup.keyboard": "Keyboard and button layouts",
    "arrangementGroup.strings": "String instrument fretboards",
    "arrangementVariant.standard": "Standard",
    "arrangementVariant.wide": "Wide",
    "arrangementVariant.tall": "Tall",
    "arrangementVariant.slanted": "Slanted",
    "layoutHelp.third": "Semitones run horizontally; the staggered rows form major and minor third relationships.",
    "layoutHelp.fourth": "Semitones run horizontally, with a perfect fourth between rows.",
    "layoutHelp.tritone": "Semitones run horizontally, with a tritone between rows.",
    "layoutHelp.fifth": "Semitones run horizontally, with a perfect fifth between rows.",
    "layoutHelp.octave": "Semitones run horizontally, with an octave between rows.",
    "layoutHelp.tonnetz": "A lattice of fifths and thirds for exploring chord relationships.",
    "layoutHelp.wicki-hayden": "Whole tones run horizontally in a staggered layout. Choose Standard or Wide.",
    "layoutHelp.janko": "Whole tones run horizontally, with adjacent rows supplying the intervening semitones.",
    "layoutHelp.c-system": "The C-system chromatic button layout. Minor thirds run horizontally.",
    "layoutHelp.b-system": "The B-system chromatic button layout. Minor thirds run horizontally.",
    "layoutHelp.guitar": "A six-string guitar in standard tuning (E–A–D–G–B–E, low to high).",
    "layoutHelp.bass": "A four-string bass in standard tuning (E–A–D–G, low to high).",
    "layout.piano": "Piano",
    "layout.piano-vertical": "Piano (Vertical octaves)",
    "octaveDirection": "Octave direction",
    "arrangementVariant.horizontal": "Horizontal",
    "arrangementVariant.vertical": "Vertical",
    "layoutHelp.piano": "An 88-key piano (A0–C8). Octaves ascend to the right or upward, with one octave per row.",
    "layout.third": "Thirds layout",
    "layout.fourth-whole-tone": "Perfect fourth–whole tone",
    "layoutHelp.fourth-whole-tone": "Whole tones run horizontally, with a perfect fourth between rows.",
    "layout.fourth": "Perfect fourth",
    "layout.tritone": "Tritone",
    "layout.fifth-whole-tone": "Perfect fifth–whole tone",
    "layoutHelp.fifth-whole-tone": "Whole tones run horizontally, with a perfect fifth between rows.",
    "layout.fifth": "Perfect fifth",
    "layout.octave": "Octave",
    "layout.wicki-hayden": "Wicki–Hayden",
    "layout.wicki-hayden-wide": "Wicki–Hayden (Wide)",
    "layout.tonnetz": "Tonnetz",
    "layout.janko": "Jankó",
    "layout.janko-tall": "Jankó (Tall)",
    "layout.janko-slanted": "Jankó (Slanted)",
    "layout.c-system": "C-system",
    "layout.b-system": "B-system",
    "layout.guitar": "Guitar",
    "layout.bass": "Bass Guitar",
    "mode.2741": "Major (Ionian)",
    "mode.1453": "Natural Minor (Aeolian)",
    "mode.2225": "Ionian Pentatonic",
    "mode.661": "Major Pentatonic",
    "mode.1189": "Suspended Pentatonic",
    "mode.1193": "Minor Pentatonic",
    "mode.397": "Aeolian Pentatonic",
    "mode.4095": "Chromatic"
}
export default messages
